/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type APIResponseBase,
    APIResponseBaseFromJSON,
    APIResponseBaseToJSON,
} from '../models/APIResponseBase';
import {
    type GetStats200Response,
    GetStats200ResponseFromJSON,
    GetStats200ResponseToJSON,
} from '../models/GetStats200Response';
import {
    type GetStatsBilling200Response,
    GetStatsBilling200ResponseFromJSON,
    GetStatsBilling200ResponseToJSON,
} from '../models/GetStatsBilling200Response';
import {
    type GetStatsMitm200Response,
    GetStatsMitm200ResponseFromJSON,
    GetStatsMitm200ResponseToJSON,
} from '../models/GetStatsMitm200Response';

export interface GetStatsRequest {
    slashIDOrgID: string;
    bin: GetStatsBinEnum;
    start?: Date;
    end?: Date;
}

export interface GetStatsBillingRequest {
    slashIDOrgID: string;
    start?: Date;
    end?: Date;
}

export interface GetStatsMitmRequest {
    slashIDOrgID: string;
    start?: Date;
    end?: Date;
}

/**
 * 
 */
export class StatsApi extends runtime.BaseAPI {

    /**
     * Creates request options for getStats without sending the request
     */
    async getStatsRequestOpts(requestParameters: GetStatsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getStats().'
            );
        }

        if (requestParameters['bin'] == null) {
            throw new runtime.RequiredError(
                'bin',
                'Required parameter "bin" was null or undefined when calling getStats().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['bin'] != null) {
            queryParameters['bin'] = requestParameters['bin'];
        }

        if (requestParameters['start'] != null) {
            queryParameters['start'] = (requestParameters['start'] as any).toISOString();
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = (requestParameters['end'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stats`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */
    async getStatsRaw(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStats200Response>> {
        const requestOptions = await this.getStatsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStats200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about organization activity
     */
    async getStats(requestParameters: GetStatsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStats200Response> {
        const response = await this.getStatsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStatsBilling without sending the request
     */
    async getStatsBillingRequestOpts(requestParameters: GetStatsBillingRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getStatsBilling().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['start'] != null) {
            queryParameters['start'] = (requestParameters['start'] as any).toISOString();
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = (requestParameters['end'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stats/billing`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */
    async getStatsBillingRaw(requestParameters: GetStatsBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStatsBilling200Response>> {
        const requestOptions = await this.getStatsBillingRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStatsBilling200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about billable organization activity. Aggregated stats are bound at the 1st day of each month
     */
    async getStatsBilling(requestParameters: GetStatsBillingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStatsBilling200Response> {
        const response = await this.getStatsBillingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getStatsMitm without sending the request
     */
    async getStatsMitmRequestOpts(requestParameters: GetStatsMitmRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['slashIDOrgID'] == null) {
            throw new runtime.RequiredError(
                'slashIDOrgID',
                'Required parameter "slashIDOrgID" was null or undefined when calling getStatsMitm().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['start'] != null) {
            queryParameters['start'] = (requestParameters['start'] as any).toISOString();
        }

        if (requestParameters['end'] != null) {
            queryParameters['end'] = (requestParameters['end'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['slashIDOrgID'] != null) {
            headerParameters['SlashID-OrgID'] = String(requestParameters['slashIDOrgID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stats/mitm`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */
    async getStatsMitmRaw(requestParameters: GetStatsMitmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetStatsMitm200Response>> {
        const requestOptions = await this.getStatsMitmRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetStatsMitm200ResponseFromJSON(jsonValue));
    }

    /**
     * This endpoint is private and meant for console metrics. 
     * Get event-based statistics about MITM detections, grouped by proxied domain.
     */
    async getStatsMitm(requestParameters: GetStatsMitmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetStatsMitm200Response> {
        const response = await this.getStatsMitmRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetStatsBinEnum = {
    NUMBER_60: 60,
    NUMBER_1440: 1440,
    NUMBER_43200: 43200
} as const;
export type GetStatsBinEnum = typeof GetStatsBinEnum[keyof typeof GetStatsBinEnum];
